<template>
  <div
    class="dialog_container"
    @click="$emit('click')"
  >
    <div
      id="dialogoverlay"
      class="dialog_overlay"
      @click="$emit('close')"
    ></div>
    <div
      class="dialog_content"
      :class="`dialog_content_${dialog.animationType}`"
    >
      <div
        class="dialog_content_close mdi icon_btn mdi-close"
        :data-tst="`dialog_${dialog.dialog}_close`"
        :style="dialog.closeStyle"
        @click="$emit('close')"
      ></div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'DialogOverlay',
  props: {
    dialog: Object,
  },
  emits: ['click', 'close'],
  data() {
    return {
      dialogs: [],
    }
  },
}
</script>

<style lang="scss" scoped>
// global styles for transition are in AppDialogs.vue
</style>
